import FullWidthBarBreadcrumbs from '@/components/Breadcrumb/FullWidthBarBreadcrumbs';
import SmartLink from '@/components/Button/SmartLink';
import CenteredContentSection from '@/components/ContentSection/CenteredContentSection';
import DescirptionContainer from '@/components/DescriptionList/DescriptionContainer';
import DescriptionRow from '@/components/DescriptionList/DescriptionRow';
import { H3 } from '@/components/Element/Heading';
import MetaTags from '@/components/Head/MetaTags';
import SimpleCenteredHeaderSection from '@/components/HeaderSection/SimpleCenteredHeaderSection';
import VerticalLeadFormSection from '@/components/LeadForm/VerticalLeadFormSection';
import { getIncentive } from 'data/dsire';
import { Incentive } from 'data/types';
import { YEAR } from 'lib/constants';
// import { OrganizationJsonLd } from 'next-seo';

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

type StaticProps = {
  params: {
    incentive_slug: string;
  };
};

export async function getStaticProps({
  params: { incentive_slug },
}: StaticProps) {
  const incentive = await getIncentive(incentive_slug);
  return { props: { incentive } };
}

type Props = {
  incentive: Incentive;
};

export default function Page({ incentive }: Props) {
  return (
    <article>
      <MetaTags title={`${incentive.name} - ${incentive.state}`} />
      {/* <OrganizationJsonLd
        type="Corporation"
        name={manufacturer.name}
        legalName={manufacturer.legalName}
        logo={manufacturer.webpPath}
        // address={manufacturer.address}
        url={`https://energypal.com/best-solar-inverters-for-homes/${manufacturer.slug}`}
      /> */}
      <SimpleCenteredHeaderSection
        dark
        supTitle={`Buyer's Guide ${YEAR}`}
        title={incentive.name}
        subTitle="Solar &amp; Battery Regulation &amp; Incentive Programs"
      />
      <FullWidthBarBreadcrumbs
        pages={[
          {
            name: 'Resources',
            href: '/solar-customer-resources',
          },
          {
            name: 'Best Solar Panels for Homes',
            href: '/solar-energy-storage-incentive-programs',
          },
          {
            name: incentive.name,
            href: `/solar-energy-storage-incentive-programs/${incentive.slug}`,
          },
        ]}
      />
      <CenteredContentSection>
        <H3>Program Overview</H3>
        <DescirptionContainer>
          <DescriptionRow label="Category">{incentive.category}</DescriptionRow>
          <DescriptionRow label="Program Type">{incentive.type}</DescriptionRow>
          <DescriptionRow label="Implementing Sector">
            {incentive.ImplementingSectorName?.toString()}
          </DescriptionRow>
          <DescriptionRow label="State">{incentive.state}</DescriptionRow>
          {incentive.technologies.length > 0 && (
            <DescriptionRow label="Eligible Storage Technologies">
              {incentive.technologies.map((res) => res.name).join(', ')}
            </DescriptionRow>
          )}
          {incentive.website && (
            <DescriptionRow label="Website">
              <SmartLink href={incentive.website}>
                {incentive.website}
              </SmartLink>
            </DescriptionRow>
          )}

          {incentive.details.length > 0 && (
            <>
              {incentive.details
                .filter((d) => !!d.value)
                .map((detail) => (
                  <DescriptionRow key={detail.id} label={detail.label}>
                    <div dangerouslySetInnerHTML={{ __html: detail.value }} />
                  </DescriptionRow>
                ))}
            </>
          )}
          <DescriptionRow label="Administrator">
            {incentive.Administrator?.toString()}
          </DescriptionRow>
          {incentive.sectors.length > 0 && (
            <DescriptionRow label="Applicable Sectors">
              {incentive.sectors.map((res) => res.name).join(', ')}
            </DescriptionRow>
          )}
          <DescriptionRow label="Budget">
            {incentive.Budget?.toString()}
          </DescriptionRow>
          {incentive.StartDate && (
            <DescriptionRow label="Start Date">
              {incentive.StartDate?.toString()}
            </DescriptionRow>
          )}
          {incentive.EndDate && (
            <DescriptionRow label="End Date">
              {incentive.EndDate?.toString()}
            </DescriptionRow>
          )}
          {incentive.utilities.length > 0 && (
            <DescriptionRow label="Applicable Utilities">
              {incentive.utilities.map((res) => res.name).join(', ')}
            </DescriptionRow>
          )}
          {/* Counties, Citie, ZipCodes, Contacts, ProgramParameters, Authorities */}

          <DescriptionRow label="Last Updated">
            {incentive.LastUpdate?.toString()}
          </DescriptionRow>
          <DescriptionRow label="Funding Source">
            {incentive.FundingSource?.toString()}
          </DescriptionRow>
        </DescirptionContainer>
      </CenteredContentSection>
      <VerticalLeadFormSection />
    </article>
  );
}
